import styled from 'styled-components';

export const PageWrap = styled.div`
  background: var(--bg-section);
  min-height: calc(100vh - 68px);
  padding-bottom: var(--spacing-3xl);
`;

export const Hero = styled.section`
  background: var(--gradient-hero);
  border-bottom: 1px solid var(--border-light);
  padding: var(--spacing-2xl) 20px;
`;

export const HeroInner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-lg);
  min-width: 0;

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

export const Logo = styled.div`
  width: 112px;
  height: 112px;
  flex-shrink: 0;
  border-radius: var(--radius-xl);
  background: var(--bg-card);
  border: 1px solid var(--border-light);
  box-shadow: var(--shadow-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  font-size: var(--text-4xl);
  font-weight: 700;
  color: var(--primary);

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
`;

export const HeroText = styled.div`
  flex: 1;
  min-width: 0;

  h1 {
    font-size: var(--text-3xl);
    letter-spacing: -0.5px;
    overflow-wrap: anywhere;
  }

  .city {
    color: var(--text-secondary);
    margin-top: 4px;
  }

  .description {
    color: var(--text-secondary);
    line-height: 1.6;
    margin-top: var(--spacing-md);
    max-width: 720px;
    white-space: pre-line;
    overflow-wrap: anywhere;
  }

  .share {
    margin-top: var(--spacing-md);
  }

  @media (max-width: 640px) {
    .share > div { justify-content: center; }
  }
`;

export const Section = styled.section`
  max-width: 1100px;
  margin: 0 auto;
  padding: var(--spacing-xl) 20px 0;

  h2 {
    font-size: var(--text-2xl);
    margin-bottom: var(--spacing-lg);
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 260px), 1fr));
  gap: var(--spacing-lg);
`;

export const Card = styled.a`
  display: block;
  min-width: 0;
  background: var(--bg-card);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-lg);
  overflow: hidden;
  color: inherit;
  text-decoration: none;
  box-shadow: var(--shadow-card);
  transition: transform var(--transition-normal), box-shadow var(--transition-normal);

  &:hover,
  &:focus-visible {
    transform: translateY(-4px);
    box-shadow: var(--shadow-hover);
  }

  img {
    width: 100%;
    height: 180px;
    object-fit: cover;
    display: block;
    background: var(--bg-input);
  }

  .body {
    padding: var(--spacing-md);
  }

  h3 {
    font-size: var(--text-lg);
    line-height: 1.3;
    margin-bottom: 6px;
    overflow-wrap: anywhere;
  }

  p {
    color: var(--text-secondary);
    font-size: var(--text-sm);
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: var(--spacing-sm);
  }

  .meta {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 4px 12px;
    font-size: var(--text-sm);
    color: var(--text-muted);
  }

  .price {
    font-weight: 700;
    color: var(--primary);
    font-size: var(--text-lg);
  }
`;

export const Notice = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding: var(--spacing-3xl) 20px;
  text-align: center;

  h1 { margin-bottom: var(--spacing-sm); }

  p {
    color: var(--text-secondary);
    margin-bottom: var(--spacing-lg);
  }

  .emoji {
    font-size: 56px;
    margin-bottom: var(--spacing-md);
  }

  .buttons {
    display: flex;
    flex-wrap: wrap;
    gap: var(--spacing-md);
    justify-content: center;
  }
`;

export const EmptyActivities = styled.div`
  background: var(--bg-card);
  border: 1px dashed var(--border-medium);
  border-radius: var(--radius-lg);
  padding: var(--spacing-xl) var(--spacing-lg);
  text-align: center;
  color: var(--text-secondary);
`;
